import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../App';
import DropMenu from './common/dropmenu';
import NavMenu from './NavMenu';

const Header = () => {

  return ( 
    <React.Fragment>
    <NavMenu />
    <div className="nb">
      <div className="flex aic">
        <div className="flex nw">
          <img src="https://i.wpcrawl.com/2022/08/wpc-96.png" id="logo" alt="WPCrawl" width="50" height="50" />
          <Link className="brand" to="/">WPCrawl</Link>
          <span>beta</span>
        </div>
        <div className="act">
          {renderUser()}
        </div>
      </div>
    </div>
    </React.Fragment>
  );
}

function renderUser() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { user, appUser, sites } = useContext(UserContext);

  if (user && user.displayName ) {
    return (
      <div>
        <DropMenu
          title = {
            <div className="flex aic">
              <span className="name">{user.displayName}</span>
              <img
                className="avatar"
                src={user.photoURL}
                alt={`${user.displayName}’s avatar`}
                width="40"
                height="40"
              />
            </div>
          }>
            <Link to={`/logout`} className="" >Logout</Link>
          </DropMenu>
      </div>
    );
  } else {
    return (
      <div className="">
        <Link to="/login" className="px">Login</Link>
        <Link to="/register" className="btn">Register</Link>
      </div>
    );
  }
}

export default Header;